import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import "./Evaluate.scss";
class Evaluate extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <section className="hot-features-area">
          {/* //Thay bằng video */}
          {/* <div className="electrode-bg">
            <video
              id="homeVideo"
              autoPlay
              loop
              muted
              preload="auto"
              poster="/static/images/banner/banner02.png"
            >
              <source
                src="/static/video/anovator_v2-banner.mp4"
                type="video/mp4"
              />
            </video>
          </div> */}

          <div className="container electrode-title-box">
            <div
              className="section-header-2 animated fadeInDown"
              style={{ textAlign: "left" }}
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              {/* <div className="section-description">
                <p className="features-title">
                    <span>
                      <FormattedMessage id="home.evaluate.features-title.a1" />
                      <span style={{ fontWeight: 600 }}>
                        <FormattedMessage id="home.evaluate.features-title.a2" />
                      </span>
                      <FormattedMessage id="home.evaluate.features-title.a3" />
                    </span>
                  </p>
              </div>
              <p className="features-subtitle">
                <FormattedMessage id="home.evaluate.features-title.a4" />
              </p> */}
            </div>
          </div>
          <div className="electrode-content">
            <div className="electrode-row">
              <div className="electrode-col electrode-bg1">
                <div className="hand-box">
                  <img src="static/images/body-shou.png" alt="none" />
                  <div className="feet-desc">
                    <FormattedMessage id="home.evaluate.feet-desc.a1" />
                    <br />
                    <FormattedMessage id="home.evaluate.feet-desc.a2" />
                  </div>
                </div>
                <div className="foot-box">
                  <img src="static/images/body-jiao.png" alt="none" />
                </div>
                <div className="body-box">
                  <img src="static/images/body-jd.png" alt="none" />
                </div>
              </div>
              <div className="electrode-col justify-content-center">
                <h3
                  style={{ color: "#FFFFFF", marginBottom: 20, marginTop: 70 }}
                >
                  <FormattedMessage id="home.evaluate.electronic-col.a1" />
                </h3>

                <p className="text-align-justify">
                  <FormattedMessage id="home.evaluate.electronic-col.a2" />
                </p>
                <p className="text-align-justify">
                  <FormattedMessage id="home.evaluate.electronic-col.a3" />
                </p>
              </div>
            </div>
            <div className="electrode-row">
              <div className="electrode-col electrode-text">
                <h3 style={{ color: "#FFFFFF", marginBottom: 20 }}>
                  <FormattedMessage id="home.evaluate.electronic-col.a4" />
                  <br />
                </h3>
                <p className="text-align-justify">
                  <FormattedMessage id="home.evaluate.electronic-col.a5" />
                </p>
              </div>
              <div className="electrode-col electrode-bg2">
                <div className="body-box">
                  <img src="/static/images/body-guge.png" alt="none" />
                </div>
                <div className="electrode-desc">
                  <FormattedMessage id="home.evaluate.electronic-col.a6" />
                  <br />
                  <FormattedMessage id="home.evaluate.electronic-col.a7" />
                </div>
                <div className="body-box">
                  <img src="static/images/body-weidu.png" alt="none" />
                </div>
                <div className="electrode-desc">
                  <FormattedMessage id="home.evaluate.electronic-col.a8" />
                  <br />
                  <FormattedMessage id="home.evaluate.electronic-col.a9" />
                </div>
              </div>
            </div>
            <div className="electrode-row">
              <div
                className="electrode-col electrode-bg3"
                style={{ backgroundColor: "#000000" }}
              >
                <div className="shili-box">
                  <img src="static/images/shili.png" alt="none" />
                </div>
                <div className="fjx-box">
                  <div>
                    <img src="static/images/xinlv.png" alt="none" />
                  </div>
                  <div>
                    <img
                      style={{ marginTop: 20 }}
                      src="static/images/xueyang.png"
                      alt="none"
                    />
                  </div>
                </div>
              </div>
              <div className="electrode-col electrode-text">
                <h3 style={{ color: "#FFFFFF", marginBottom: 20 }}>
                  <FormattedMessage id="home.evaluate.electronic-col.a10" />
                </h3>
                <p className="text-align-justify">
                  <FormattedMessage id="home.evaluate.electronic-col.a11" />
                </p>
                <p className="text-align-justify">
                  <FormattedMessage id="home.evaluate.electronic-col.a12" />
                </p>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Evaluate)
);
